module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Ballet RO.644e170d.png";